module.exports = __webpack_public_path__ + "static/media/zoom.ca38b36f.svg";